<template>
  <button type="button" class="toolbarBtn"
    :class="{active: active}"
    @mousedown.prevent
    @click="onClick">
    <img src="~@/assets/img/CITEditor/orderedlist.svg" alt="oldered list" title="oldered list" />
  </button>
</template>

<script>
export default {
  name: 'OrderedList',
  props: [
    'active'
  ],
  methods: {
    onClick () {
      document.execCommand('insertOrderedList', false)
    }
  }
}
</script>
